module.exports = "<p>\n  category works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/pages/category/category.component.html
// module id = ../../../../../src/app/pages/category/category.component.html
// module chunks = main